import { MutationTree } from 'vuex'
import { SET_USERS, SET_PEERS } from '@/store/share/constants'
import { ShareState } from '@/store/share/types'
import { UserWithKey } from '@/types/user'

const mutations: MutationTree<ShareState> = {
    /**
     * Set organisation user list
     */
    [SET_USERS](state, users: UserWithKey[]) {
        state.users = users
    },

    /**
     * Set list of peers who have access to the entry
     */
    [SET_PEERS](state, peers: UserWithKey[]) {
        state.peers = peers
    }
}

export default mutations
